import { http } from "../base";

class JsonService {
    async getPrintSetting(printerName: String) {
        return http.getData(`/${printerName}.json`);
    }
}

export const jsonService = new JsonService();